import { render, staticRenderFns } from "./BoletimUrna.vue?vue&type=template&id=0a42ef53&scoped=true&"
import script from "./BoletimUrna.vue?vue&type=script&lang=js&"
export * from "./BoletimUrna.vue?vue&type=script&lang=js&"
import style0 from "./BoletimUrna.vue?vue&type=style&index=0&id=0a42ef53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a42ef53",
  null
  
)

export default component.exports